import { useMemo } from 'react';
import { useScene } from 'src/hooks/useScene';
import { useUiStateStore } from 'src/stores/uiStateStore';
import { ConnectorWaypoints } from './ConnectorWaypoints';

interface Props {
  connectors: ReturnType<typeof useScene>['connectors'];
}

export const ConnectorHandles = ({ connectors }: Props) => {
  const { currentView } = useScene();
  const itemControls = useUiStateStore((state) => state.itemControls);
  const mode = useUiStateStore((state) => state.mode);

  const selectedConnectorId = useMemo(() => {
    if (mode.type === 'CONNECTOR') return mode.id;
    if (itemControls?.type === 'CONNECTOR') return itemControls.id;
    if (itemControls?.type === 'CONNECTOR_ANCHOR') {
      return connectors.find((connector) =>
        connector.anchors.some((anchor) => anchor.id === itemControls.id)
      )?.id ?? null;
    }
    return null;
  }, [mode, itemControls, connectors]);

  const activeAnchorId = mode.type === 'DRAG_ITEMS'
    ? mode.items.find((item) => item.type === 'CONNECTOR_ANCHOR')?.id ?? null
    : itemControls?.type === 'CONNECTOR_ANCHOR'
      ? itemControls.id
      : null;

  const selectedConnector = connectors.find(
    (connector) => connector.id === selectedConnectorId
  );

  return selectedConnector ? (
    <ConnectorWaypoints
      connector={selectedConnector}
      view={currentView}
      activeAnchorId={activeAnchorId}
    />
  ) : null;
};
